import { render, staticRenderFns } from "./PaymentHistoryItem.vue?vue&type=template&id=1a635ae6&"
import script from "./PaymentHistoryItem.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a635ae6')) {
      api.createRecord('1a635ae6', component.options)
    } else {
      api.reload('1a635ae6', component.options)
    }
    module.hot.accept("./PaymentHistoryItem.vue?vue&type=template&id=1a635ae6&", function () {
      api.rerender('1a635ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/components/PaymentHistoryItem.vue"
export default component.exports